import { useState } from 'react'
import * as S from './PetPortraitHeroSection.styles'
import * as SectionStyles from '../heroSection.styles'
import * as HeroStyles from '../heroOverlay.styles'
import GlassButton from 'components/GlassButton/GlassButton'
import useScreenSize from 'hooks/useScreenSize'
import {
  type CtaLink,
  type HeroPlayback,
  type HeroVideo,
  MULTI_PRODUCT_NAV_STATE,
  MULTI_PRODUCT_VIDEO_FOLDER,
} from '../../multiProductHomePage.consts'

type Props = {
  introVideo: HeroVideo
  loopVideo: HeroVideo
  playback: HeroPlayback
  onPlayedOnce: () => void
  title: string
  subtitle: string
  explore: CtaLink
  testId: string
}

// Intro plays once on reveal, then unmounts to reveal the preloaded loop underneath.
// The loop stays display:none until the swap so it doesn't compete for playback.
export default function PetPortraitHeroSection({
  introVideo,
  loopVideo,
  playback,
  onPlayedOnce,
  title,
  subtitle,
  explore,
  testId,
}: Props) {
  const [phase, setPhase] = useState<'intro' | 'loop'>('intro')
  const isMediumScreen = useScreenSize('md')
  const shouldAutoPlay = playback !== 'wait'

  return (
    <SectionStyles.Section data-testid={testId}>
      <S.VideoLayer
        key={loopVideo.cldId}
        cldId={loopVideo.cldId}
        folder={MULTI_PRODUCT_VIDEO_FOLDER}
        cldWidth={loopVideo.cldWidth}
        name="Pet Portraits Loop"
        type="Video"
        preload="auto"
        loop={playback === 'loop'}
        shouldAutoPlay={shouldAutoPlay}
        onVideoEnd={() => {
          if (playback === 'play-once') onPlayedOnce()
        }}
        $hidden={phase === 'intro'}
      />
      {phase === 'intro' && (
        <S.VideoLayer
          key={introVideo.cldId}
          cldId={introVideo.cldId}
          folder={MULTI_PRODUCT_VIDEO_FOLDER}
          cldWidth={introVideo.cldWidth}
          name="Pet Portraits Intro"
          type="Video"
          preload="auto"
          loop={false}
          shouldAutoPlay={shouldAutoPlay}
          onVideoEnd={() => setPhase('loop')}
        />
      )}
      <HeroStyles.Overlay>
        <HeroStyles.TextBlock>
          <HeroStyles.Title>{title}</HeroStyles.Title>
          <HeroStyles.Subtitle>{subtitle}</HeroStyles.Subtitle>
        </HeroStyles.TextBlock>
        <HeroStyles.Buttons>
          <GlassButton
            variant="primary"
            size={isMediumScreen ? 'medium' : 'small'}
            to={explore.to}
            state={MULTI_PRODUCT_NAV_STATE}
            onClick={explore.onClick}
            data-testid={`${testId}-explore`}
          >
            {explore.label}
          </GlassButton>
        </HeroStyles.Buttons>
      </HeroStyles.Overlay>
    </SectionStyles.Section>
  )
}
